import { getRouterValue, useSetRouterValue } from '../../hooks'

type OnBackFunction = () => void | 'closeApp'

const CUSTOM_BACKS_NAME = 'custom-backs'

export function getHistoryCustomBack(panel: string): OnBackFunction {
  return getRouterValue(CUSTOM_BACKS_NAME, panel)
}

export function useHistoryCustomBack(
  onBack: OnBackFunction,
  deps: any[],
  isActive = true,
) {
  useSetRouterValue(CUSTOM_BACKS_NAME, () => onBack, deps, isActive)
}
